import { Operator } from '@/api/dtos/Operator.schema'
import { OperatorSummary } from '@/api/dtos/OperatorSummary.schema'
import store from '@/store'
import * as operatorApi from '@/api/operators'
import {
  Module,
  VuexModule,
  Mutation,
  Action,
  MutationAction,
  getModule
} from 'vuex-module-decorators'
import moment from 'moment'

export interface IOperatorStoreState {
  detailedOperator: Operator | null
  operatorSummaries: OperatorSummary[]
}

@Module({ dynamic: true, store, name: 'operators' })
class Operators extends VuexModule implements IOperatorStoreState {
  public detailedOperator: Operator | null = null
  public operatorSummaries: OperatorSummary[] = []

  @MutationAction({ mutate: ['operatorSummaries'] })
  public async fetchOperatorSummaries (): Promise<{
    operatorSummaries: OperatorSummary[]
  }> {
    return {
      operatorSummaries:
        await operatorApi.getOperators()

    }
  }

  @MutationAction({ mutate: ['detailedOperator'] })
  public async fetchOperator (
    operatorId: string
  ): Promise<{ detailedOperator: Operator }> {
    return {
      detailedOperator: await operatorApi.getOperator(operatorId)
      // {
      //   uuid: 'j8dz89qdfqwgdzgqw',
      //   reminderMailSettings: {
      //     firstReminder: moment.duration(1, 'days').toISOString(),
      //     secondReminder: moment.duration(0.5, 'days').toISOString()
      //   },
      //   owners: [],
      //   managers: [
      //     {
      //       stations: [],
      //       user: {
      //         userUuid: 'fwefwefwef',
      //         email: 's23452t@edsde.de',
      //         isAdmin: false,
      //         isBanned: false,
      //         lastLogin: '2022-01-21T11:19:05.787Z',
      //         isManager: true,
      //         isOwner: true,
      //         isEnduser: true
      //       }
      //     },
      //     {
      //       stations: [
      //         {
      //           isActive: true,
      //           currentUtilization: 0,
      //           platformServiceActive: false,
      //           lastOnline: '2022-01-21T11:19:05.787Z',
      //           maxUtilization: 12,
      //           operatorSummary: {
      //             name: 'Testoperator 3',
      //             uuid: 'myoperatorSummary.uuid3333333'
      //           },
      //           stationLocation: {
      //             address: {
      //               city: 'Dresden',
      //               country: 'DE',
      //               postalCode: '01099',
      //               street: 'Schwerinerstraße 12'
      //             },
      //             lat: 23,
      //             lon: 43,
      //             stationName: 'Lübben Nebenbahnhof'
      //           },
      //           stationUuid: 'mystationuuid333333333z'
      //         }
      //       ],
      //       user: {
      //         userUuid: 'r238z2349',
      //         email: 's23452t@edsde.de',
      //         isAdmin: false,
      //         isBanned: false,
      //         lastLogin: new Date().toISOString(),
      //         isManager: true,
      //         isOwner: true,
      //         isEnduser: true
      //       }
      //     },
      //     {
      //       stations: [
      //         {
      //           isActive: true,
      //           currentUtilization: 6,
      //           platformServiceActive: true,
      //           lastOnline: '2022-01-21T11:19:05.787Z',
      //           maxUtilization: 12,
      //           operatorSummary: {
      //             name: 'Testoperator 1',
      //             uuid: 'myoperatorSummary.uuid1111111111'
      //           },
      //           stationLocation: {
      //             address: {
      //               city: 'Dresden',
      //               country: 'DE',
      //               postalCode: '01099',
      //               street: 'Schwerinerstraße 12'
      //             },
      //             lat: 42,
      //             lon: 23,
      //             stationName: 'Lübben Hauptbahnhof'
      //           },
      //           stationUuid: 'mystationuuid1111111111'
      //         }
      //       ],
      //       user: {
      //         userUuid: '3423fef',
      //         email: 's23452t@edsde.de',
      //         isAdmin: false,
      //         isBanned: false,
      //         lastLogin: new Date().toISOString(),
      //         isManager: true,
      //         isOwner: true,
      //         isEnduser: true
      //       }
      //     }
      //   ],
      //   platformServiceActive: false,
      //   isActive: true,
      //   finance: {
      //     BIC: 'BYLADEM1001',
      //     IBAN: 'DE02120300000000202051',
      //     payOneAPIkey: 'ka9dhz8qghuaegbu79qe',
      //     salesTaxRate: 19,
      //     ustId: 'DE123456789',
      //     ustNr: '234234'
      //   },
      //   emailTemplates: [
      //     {
      //       name: 'Testemail1',
      //       obligatoryPlaceholders: ['c', 'd'],
      //       richText:
      //         '<h1>Yay Headlines!</h1><p>All these <strong>cool tags</strong> are working now.</p>',
      //       uuid: '8u89z5345345345dzasd',
      //       voluntaryPlaceholders: ['a', 'b']
      //     },
      //     {
      //       name: 'Testemail2',
      //       obligatoryPlaceholders: ['c', 'd'],
      //       richText:
      //         '<h1>Yay Headlines!</h1><p>All these <strong>cool tags</strong> are working now.</p>',
      //       uuid: '8u567567567dhaszbdzasd',
      //       voluntaryPlaceholders: ['a', 'b']
      //     },
      //     {
      //       name: 'Testemail3',
      //       obligatoryPlaceholders: ['c', 'd'],
      //       richText:
      //         '<h1>Yay Headlines!</h1><p>All these <strong>cool tags</strong> are working now.</p>',
      //       uuid: '0809089089zbdzasd',
      //       voluntaryPlaceholders: ['a', 'b']
      //     }
      //   ],
      //   documentSettings: {
      //     sendMailOnDataprotectionChanged: false,
      //     sendMailOnGtcChanged: false
      //   },
      //   contact: {
      //     address: {
      //       city: 'Dresden',
      //       country: 'DE',
      //       postalCode: '01099',
      //       street: 'Öderanerstraße 8'
      //     },
      //     archiveEmail: 'test1@email.com',
      //     defaultBookingEmail: 'test2@email.com',
      //     name: 'Geesthacht Stadtverwaltung',
      //     shouldReceiveBookingNotifications: true
      //   },
      //   cards: [
      //     {
      //       isServiceCard: false,
      //       name: 'Karte 1',
      //       uid: 'zu78qef87vzqgv9zeqb'
      //     },
      //     {
      //       isServiceCard: false,
      //       name: 'Karte 2',
      //       uid: 'rl89qfhzuegfzbdhuv'
      //     },
      //     {
      //       isServiceCard: true,
      //       name: 'Karte 3',
      //       uid: '53453tgfgdsfgfgfsd'
      //     },
      //     {
      //       isServiceCard: false,
      //       name: 'Karte 4',
      //       uid: 'r24rwgrgfgbdfbdfb'
      //     }
      //   ]
      // }
    }
  }

  @MutationAction({ mutate: ['detailedOperator'] })
  public async refreshDetailedOperator (): Promise<{
    detailedOperator: Operator
  }> {
    if (!this.detailedOperator) {
      throw Error('no detailed operator to refresh present!')
    }
    return {
      detailedOperator: await operatorApi.getOperator(
        this.detailedOperator.uuid
      )
    }
  }
}

export const OperatorsModule = getModule(Operators)
